import { getDateLast15MinuteStep, getTimezoneAbbreviation } from '../utils';
import { isFirstDayOfMonth, isSameDay, convertToSiteTz, genericDateFormat, } from './date';
import { DateTime } from 'luxon';
import omit from 'ramda/src/omit';
import pick from 'ramda/src/pick';
export function createNotificationDateFilter(ianaTimeZoneCode) {
    return Object.values(createTimeFilterMapping({
        ianaTimeZoneCode,
        useCurrentTime: true,
    }));
}
export function getDateFiltersWithoutTodayOrYesterday(ianaTimeZoneCode) {
    const timeFilterOptions = createTimeFilterMapping({ ianaTimeZoneCode });
    return Object.values(pick(['last7Days', 'last30Days', 'thisMonth', 'lastMonth'], timeFilterOptions));
}
export function createTimeFilterMapping(options) {
    let { useCurrentTime, ianaTimeZoneCode } = options || {};
    const nowInJSDate = useCurrentTime ? new Date() : getDateLast15MinuteStep();
    const nowInDateTime = DateTime.fromJSDate(nowInJSDate).setZone(ianaTimeZoneCode);
    const startOfToday = nowInDateTime.startOf('day');
    const startOfYesterday = nowInDateTime.minus({ day: 1 }).startOf('day');
    const endOfYesterday = nowInDateTime.minus({ day: 1 }).endOf('day');
    const sevenDaysAgo = nowInDateTime.minus({ days: 7 }).startOf('day');
    const thirtyDaysAgo = nowInDateTime.minus({ days: 30 }).startOf('day');
    const startOfMonth = nowInDateTime.startOf('month');
    const endOfLastMonth = nowInDateTime.minus({ month: 1 }).endOf('month');
    const startOfLastMonth = endOfLastMonth.startOf('month');
    let timeFilterObject = {
        today: {
            title: 'Today',
            fromDate: startOfToday.toJSDate(),
            toDate: nowInDateTime.toJSDate(),
        },
        yesterday: {
            title: 'Yesterday',
            fromDate: startOfYesterday.toJSDate(),
            toDate: endOfYesterday.toJSDate(),
        },
        last7Days: {
            title: 'Last 7 days',
            fromDate: sevenDaysAgo.toJSDate(),
            toDate: endOfYesterday.toJSDate(),
        },
        last30Days: {
            title: 'Last 30 days',
            fromDate: thirtyDaysAgo.toJSDate(),
            toDate: endOfYesterday.toJSDate(),
        },
        thisMonth: {
            title: 'This month',
            fromDate: startOfMonth.toJSDate(),
            toDate: endOfYesterday.toJSDate(),
        },
        lastMonth: {
            title: 'Last month',
            fromDate: startOfLastMonth.toJSDate(),
            toDate: endOfLastMonth.toJSDate(),
        },
    };
    //we remove the "This Month" option on the first of every month
    //because the toDate (endOfYesterday) would be before fromDate (startOfMonth)
    //I figure this would be better than conditional "This Month" logic
    if (isFirstDayOfMonth(nowInDateTime.toISO())) {
        timeFilterObject = omit(['thisMonth'], timeFilterObject);
    }
    return timeFilterObject;
}
export const createReportWizardDateFilter = (timeZone) => {
    // const yesterday = endOfDay(
    //   subDays(convertToSiteTz(new Date(), timeZone), 1)
    // );
    const yesterday = DateTime.fromJSDate(new Date())
        .setZone(timeZone)
        .minus({ day: 1 })
        .endOf('day');
    const desiredFiltersArray = Object.values(createTimeFilterMapping({ ianaTimeZoneCode: timeZone }));
    return [
        ...desiredFiltersArray.map((filterOption) => ({
            title: filterOption.title,
            fromDate: convertToSiteTz(filterOption.fromDate, timeZone),
            toDate: convertToSiteTz(filterOption.toDate, timeZone),
        })),
        {
            title: 'Custom date range',
            fromDate: yesterday,
            toDate: yesterday,
        },
    ];
};
export function formatDateFilterTitle(from, to, dateFormat, timeFormat, timeZone, showTimezone) {
    const fromDate = timeZone ? convertToSiteTz(from, timeZone) : from;
    const toDate = timeZone ? convertToSiteTz(to, timeZone) : to;
    const fromTz = timeZone && showTimezone ? getTimezoneAbbreviation(timeZone) : '';
    const toTz = timeZone && showTimezone ? getTimezoneAbbreviation(timeZone) : '';
    let formatString = `${dateFormat}${timeFormat ? ` ${timeFormat}` : ''}`;
    if (fromDate === toDate) {
        return genericDateFormat(fromDate, formatString, timeZone);
    }
    if (isSameDay(DateTime.fromJSDate(fromDate).toISO(), DateTime.fromJSDate(toDate).toISO(), timeZone)) {
        if (timeFormat) {
            return `${genericDateFormat(fromDate, formatString, timeZone)} - ${genericDateFormat(toDate, timeFormat, timeZone)}${timeZone && showTimezone ? ` ${getTimezoneAbbreviation(timeZone)}` : ''}`;
        }
        return `${genericDateFormat(fromDate, dateFormat, timeZone)}${timeZone && showTimezone ? ` ${getTimezoneAbbreviation(timeZone)}` : ''}`;
    }
    return `${genericDateFormat(fromDate, formatString, timeZone)}${fromTz === toTz ? '' : ' ' + fromTz} - ${genericDateFormat(toDate, formatString, timeZone)} ${toTz}`;
}
